import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { Locale } from '../../../../core/i18n/Locale';
import { generateUrl } from '../../../../shared/utilities/routing/routing';
import { handleResponse } from '../../../shared/types/handlers';
import { CountryAndPlaceSearchItem } from '../domain/types/countryAndPlaceSearch';

import {
    CountryAndPlaceSearchResultFromPyrite,
    normalizeCountryAndPlaceSearchResultFromPyrite,
} from './normalizers';

async function fetchCountryAndPlaceSearch({ locale, query }: { locale: Locale; query: string }) {
    const response = await fetch(
        generateUrl('api_country_and_place_search', locale, {
            q: query,
        }),
    );

    return handleResponse<Array<CountryAndPlaceSearchResultFromPyrite>>(response);
}

export async function getCountryAndPlaceSearch({
    locale,
    query,
}: {
    locale: Locale;
    query: string;
}): Promise<Array<CountryAndPlaceSearchItem>> {
    // comme on ne gère pas les cas d'erreurs pour l'instant, on fait comme ci nous n'avons pas de résultats
    try {
        const response = await fetchCountryAndPlaceSearch({ locale, query });
        return response.map(normalizeCountryAndPlaceSearchResultFromPyrite);
    } catch {
        return [];
    }
}

export const useGetCountryAndPlaceSearch = ({
    locale,
    query,
    options,
}: {
    locale: Locale;
    query: string;
    options?: Omit<UseQueryOptions<Array<CountryAndPlaceSearchItem>>, 'queryKey' | 'queryFn'>;
}) => {
    return useQuery({
        queryKey: ['countryAndPlaceSearch', query],
        queryFn: () => getCountryAndPlaceSearch({ locale, query }),
        ...options,
    });
};
